import { render, staticRenderFns } from "./FilialeOverview.vue?vue&type=template&id=597a1a3f&scoped=true"
import script from "./FilialeOverview.vue?vue&type=script&lang=js"
export * from "./FilialeOverview.vue?vue&type=script&lang=js"
import style0 from "./FilialeOverview.vue?vue&type=style&index=0&id=597a1a3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597a1a3f",
  null
  
)

export default component.exports